import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import Modal from "../Modal";
import Form from "../../Form";
import { Input } from "../../Input";
import { Button } from "../../Button";
import { authApi } from "../../../hooks/authApi";
import { useTheme } from "../../../contexts/Theme/ThemeContext";
import { ReactComponent as Voltar } from "../../../assets/newImages/icons/angle-down.svg";
import { ContainerModalEsqueceuSenha, Botoes } from "./styles";

interface ModalEsqueceuSenhaProps {
  isOpen: boolean;
  setModal: (value: boolean) => void;
}

const ModalEsqueceuSenha: React.FC<ModalEsqueceuSenhaProps> = ({
  isOpen,
  setModal,
}) => {
  const { theme } = useTheme();

  const [login, setLogin] = useState("");
  const [formValid, setFormValid] = useState(false);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setLogin("");
      setLoading(false);
    }
  }, [isOpen]);

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();

    if (loading || !login.trim()) return;

    setLoading(true);
    const data = await authApi().solicitarRedefinicaoSenha(login.trim());
    setLoading(false);

    if (data && data.enviado) {
      setModal(false);
      Swal.fire({
        icon: "success",
        title: "E-mail enviado!",
        text: "Enviamos um link para o e-mail cadastrado na conta. Acesse-o para criar a nova senha, ele é válido por 30 minutos.",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (data && data.error === "TOO_MANY_REQUESTS") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Muitas tentativas seguidas, tente novamente em alguns minutos!",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (data && data.motivo === "FALHA_ENVIO") {
      Swal.fire({
        icon: "error",
        title: "Não conseguimos enviar o e-mail",
        text: "Tente novamente em alguns minutos ou entre em contato com o gerente da conta.",
        confirmButtonText: "Ok",
      });
      return;
    }

    if (data && data.motivo === "SEM_EMAIL_VINCULADO") {
      Swal.fire({
        icon: "warning",
        title: "Oops...",
        text: "Não identificamos um e-mail vinculado à sua conta. Neste caso, entre em contato com o nosso suporte.",
        showCancelButton: true,
        confirmButtonText: "Entrar em contato",
        cancelButtonText: "Fechar",
      }).then((result) => {
        if (result.isConfirmed) {
          window.open(
            "https://api.whatsapp.com/send?phone=555434434563&text=Ol%C3%A1,%20gostaria%20de%20recuperar%20minha%20senha",
            "_blank"
          );
        }
      });
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Não encontramos este usuário",
      text: "Entre em contato com o gerente da conta.",
      confirmButtonText: "Ok",
    });
  };

  return (
    <Modal isOpen={isOpen} setModal={setModal} width="500px" maxWidth="90vw">
      <ContainerModalEsqueceuSenha theme={theme}>
        <div className="titulo fonteTitulo">Esqueceu sua senha?</div>
        <div className="texto fonteRotulos">
          Informe o e-mail ou o usuário de acesso da sua conta. Enviaremos um link
          para o e-mail cadastrado para você criar uma nova senha.
        </div>
        <Form
          id="esqueceu-senha-form"
          onSubmit={handleSubmit}
          setFormValid={setFormValid}
        >
          <div className="inputs">
            <Input
              label="E-mail ou usuário"
              type="text"
              name="login"
              value={login}
              required={true}
              onChange={(newValue) => {
                setLogin(newValue);
              }}
              placeholder="E-mail ou usuário"
            />
          </div>
          <Botoes theme={theme}>
            <div
              className="cancelar fonteTexto"
              onClick={() => {
                if (!loading) setModal(false);
              }}
            >
              <Voltar /> Voltar
            </div>
            <Button
              title="Enviar"
              type="submit"
              loading={loading}
              width="25rem"
              className={`botao_alterar fonteTexto ${formValid ? "" : "disabled"}`}
            />
          </Botoes>
        </Form>
      </ContainerModalEsqueceuSenha>
    </Modal>
  );
};

export default ModalEsqueceuSenha;
